import { ActionTree } from 'vuex';
import RootState from '@/store/root_state';
import { EssayTheme, EssayState, EvaluationEssay, EssaySupportText } from './state';
import { MicroserviceEnum, mutation, query } from '@/helpers/westeros';
import {
  allEssayThemes,
  AllEssayThemesQueryResult,
  allEssaySupportTexts,
  AllEssaySupportTextsQueryResult,
} from '@/store/graphql/queries/westerosQueries';
import {
  uploadEssay,
  UploadEssayInput,
  UpsertAdmissionMutationInput,
} from '@/store/graphql/mutations/westerosMutations';

const actions: ActionTree<EssayState, RootState> = {
  async UPDATE_ESSAY_THEME({ dispatch }, payload: { essayTheme: EssayTheme }): Promise<void> {
    const { essayTheme } = payload;

    const params: UpsertAdmissionMutationInput = {
      evaluationEssay: { essayThemeId: essayTheme.id },
    };

    await dispatch('UPSERT_ADMISSION', params);
  },

  async PULL_AVAILABLE_ESSAY_THEMES({ commit }): Promise<void> {
    const { data } = await query<AllEssayThemesQueryResult>(
      MicroserviceEnum.ADMISSIONS,
      allEssayThemes,
      { isAvailable: true },
      true,
    ).catch(() => ({ data: { allEssayThemes: [] } }));

    const essayThemes: EssayTheme[] = data.allEssayThemes;

    commit('SET_AVAILABLE_ESSAY_THEMES', essayThemes);
  },

  async PULL_ESSAY_THEME_DETAILS({ commit, state }): Promise<void> {
    const { data } = await query<AllEssaySupportTextsQueryResult>(
      MicroserviceEnum.ADMISSIONS,
      allEssaySupportTexts,
      { essayThemeId: state.essayTheme?.id },
      true,
    ).catch(() => ({ data: { allEssaySupportTexts: [] } }));

    const supportTexts: EssaySupportText[] = data.allEssaySupportTexts;

    commit('SET_ESSAY_THEME', { ...state.essayTheme, supportTexts });
  },

  async UPDATE_ESSAY({ dispatch }, payload: { essay: EvaluationEssay }): Promise<void> {
    const { essay } = payload;

    const params: UpsertAdmissionMutationInput = {
      evaluationEssay: essay
        ? {
            userEssayTitle: essay.title,
            userEssayText: essay.text,
            hasAcceptedToS: essay.hasAcceptedToS,
          }
        : null,
    };

    await dispatch('UPSERT_ADMISSION', params);
  },

  async UPLOAD_ESSAY({ commit }, payload): Promise<void> {
    const { admissionId, title, text, document, uploadType } = payload;
    let args: UploadEssayInput = { admissionId };
    let evaluationEssay: EvaluationEssay = {};

    if (uploadType === 'text') {
      args = { ...args, title, text };
      evaluationEssay = { title, text };
    } else if (uploadType === 'file') {
      args = { ...args, ...document };
      evaluationEssay = { document };
    }

    await mutation<Boolean>(MicroserviceEnum.ADMISSIONS, uploadEssay, { data: args });

    commit('SET_ESSAY', evaluationEssay);
  },

  async DELETE_ESSAY_BY_FILE({ commit }): Promise<void> {
    // Deleting will stay like this or now. The user won't be able to
    // delete as uploading the essay is the last step of the admission.
    const essay: EvaluationEssay = {
      document: {},
    };

    commit('SET_ESSAY', essay);
  },
};

export default actions;
